/* Fit Craver UI fixes — bq-fixes.js
   Updated 2026-09-06.

   Products are matched by PRODUCT ID, not by Arabic title: productTitle is
   Liquid-rendered, so on /he it arrives as Hebrew and title matching silently
   switched the whole feature off. data-productid is identical in every locale.

   بنطلون (trouser size) is the deciding field. Weight is a hint only.
   The Brazilian runs ONE SIZE LARGER than the Colombian on purpose:
   same trouser size = one letter smaller. That is NOT a typo.

   NOTE: the mobile bottom toolbar's Instagram link is left alone by design —
   the merchant wants it there. An earlier version hid it; do not reinstate.
*/
(function () {
  'use strict';

  var HE = (document.documentElement.lang || '').indexOf('he') === 0;
  function t(ar, he) { return HE ? he : ar; }

  var TABLES = {
    '7371483578502': {                       /* المشد الكولومبي */
      sizes: {
        'XXS': { pants: '32-34', kg: '48-55'   },
        'XS' : { pants: '36',    kg: '56-60'   },
        'S'  : { pants: '38',    kg: '61-66'   },
        'M'  : { pants: '40',    kg: '67-75'   },
        'L'  : { pants: '42',    kg: '76-85'   },
        'XL' : { pants: '44',    kg: '86-95'   },
        '2XL': { pants: '46',    kg: '96-105'  },
        '3XL': { pants: '48',    kg: '106-115' },
        '4XL': { pants: '50',    kg: '116-125' },
        '5XL': { pants: '52',    kg: '126-145' }
      }
    },
    '7371483644038': {                       /* المشد البرازيلي */
      note: t('المشد البرازيلي أوسع بمقاس واحد عن الكولومبي. إذا كان مقاسك M في الكولومبي، فمقاسك S هنا.',
              'המחטב הברזילאי רחב במידה אחת מהקולומביאני. אם המידה שלך M בקולומביאני, המידה שלך כאן היא S.'),
      sizes: {
        'XXS': { pants: '36' }, 'XS' : { pants: '38' },
        'S'  : { pants: '40' }, 'M'  : { pants: '42' },
        'L'  : { pants: '44' }, 'XL' : { pants: '46' },
        '2XL': { pants: '48' }, '3XL': { pants: '50' },
        '4XL': { pants: '52' }
      }
    }
  };

  var TXT = {
    summary: t('📏 جدول المقاسات — اختاري حسب مقاس بنطلونك',
               '📏 טבלת מידות — בחרי לפי מידת המכנסיים שלך'),
    size:    t('المقاس',      'המידה'),
    pants:   t('بنطلون',     'מכנסיים'),
    weight:  t('الوزن (كجم)', 'משקל (ק"ג)'),
    mPants:  t('بنطلون ',    'מכנסיים '),
    mWeight: t('وزن ',        'משקל '),
    mKg:     t(' كجم',        ' ק"ג')
  };

  /* ---------- site-wide: strip stray ** markdown ---------- */
  function stripAsterisks() {
    var roots = document.querySelectorAll('[id*="announcement"], #t4s-footer');
    for (var r = 0; r < roots.length; r++) {
      var w = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null, false), n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.indexOf('**') !== -1) {
          n.nodeValue = n.nodeValue.split('**').join('');
        }
      }
    }
  }

  /* ---------- locale-proof product detection ---------- */
  function getProductId() {
    var el = document.querySelector('[data-productid]');
    return el ? el.getAttribute('data-productid') : null;
  }

  function getTable() {
    var id = getProductId();
    return (id && TABLES[id]) ? TABLES[id] : null;
  }

  /* Disable the old inline script without editing the 180KB template.
     It looks up these three ids and bails at its own guard when they
     are missing, so renaming them makes it a no-op. */
  var MSG = {};
  function takeOverPopup() {
    var map = {
      box:  't4s-size-message-popup',
      size: 't4s-popup-size',
      text: 't4s-popup-text-content'
    };
    for (var k in map) {
      var el = document.getElementById(map[k]);
      if (el) { el.id = 'bq-' + map[k]; MSG[k] = el; }
    }
  }

  function labelSwatches(sizes) {
    var items = document.querySelectorAll('[data-swatch-item]');
    for (var i = 0; i < items.length; i++) {
      var el = items[i], info = sizes[el.getAttribute('data-value')];
      if (!info || el.querySelector('.bq-pants')) continue;
      var tag = document.createElement('span');
      tag.className = 'bq-pants';
      tag.textContent = info.pants;
      el.appendChild(tag);
    }
  }

  function showMessage(val, sizes) {
    var info = sizes[val];
    if (!MSG.box || !MSG.text || !MSG.size) return;
    if (!info) { MSG.box.style.display = 'none'; return; }
    var parts = [TXT.mPants + info.pants];
    if (info.kg) parts.push(TXT.mWeight + info.kg + TXT.mKg);
    MSG.size.textContent = val;
    MSG.text.textContent = parts.join(' · ');
    MSG.box.style.display = 'block';
    MSG.box.style.opacity = '1';
  }

  /* ONE size control per page, collapsed by default. */
  function buildGuide(table) {
    var slot = document.querySelector('.t4s-product__size');

    /* The HOMEPAGE featured-product block has no `size` block, so the theme
       renders no .t4s-product__size slot there and the table used to be
       silently skipped. Create the slot ourselves, directly above the
       product form, so the table shows wherever the product is shoppable. */
    if (!slot) {
      var form = document.querySelector('form.t4s-form__product');
      if (!form || !form.parentNode) return;
      slot = document.createElement('div');
      slot.className = 't4s-product__size bq-slot--made';
      form.parentNode.insertBefore(slot, form);
    }

    if (slot.querySelector('.bq-guide')) return;

    var sizes = table.sizes;
    var available = {}, items = document.querySelectorAll('[data-swatch-item]');
    for (var i = 0; i < items.length; i++) {
      available[items[i].getAttribute('data-value')] = true;
    }

    var rows = '', hasKg = false, k;
    for (k in sizes) if (available[k] && sizes[k].kg) hasKg = true;
    for (k in sizes) {
      if (!available[k]) continue;
      rows += '<tr><td><b>' + k + '</b></td><td>' + sizes[k].pants + '</td>'
            + (hasKg ? '<td>' + (sizes[k].kg || '—') + '</td>' : '') + '</tr>';
    }
    if (!rows) return;

    slot.insertAdjacentHTML('beforeend',
      '<details class="bq-guide">' +
        '<summary>' + TXT.summary + '</summary>' +
        '<table><thead><tr><th>' + TXT.size + '</th><th>' + TXT.pants + '</th>' +
        (hasKg ? '<th>' + TXT.weight + '</th>' : '') +
        '</tr></thead><tbody>' + rows + '</tbody></table>' +
        (table.note ? '<p class="bq-note">' + table.note + '</p>' : '') +
      '</details>');
  }

  function init() {
    stripAsterisks();

    var table = getTable();
    if (!table) return;

    takeOverPopup();
    labelSwatches(table.sizes);
    buildGuide(table);

    var sel = document.querySelector('[data-swatch-item].is--selected');
    if (sel) showMessage(sel.getAttribute('data-value'), table.sizes);

    document.addEventListener('click', function (e) {
      var t2 = e.target.closest('[data-swatch-item]');
      if (t2) showMessage(t2.getAttribute('data-value'), table.sizes);
    });

    var list = document.querySelector('.t4s-swatch__list');
    if (list && window.MutationObserver) {
      new MutationObserver(function () { labelSwatches(table.sizes); })
        .observe(list, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
